// Toggle the optional $50 refundable deposit / "lock in slot" CTA.
// Hidden while building reputation — set to true to re-enable it everywhere.
export const SHOW_DEPOSIT_CTA = false;

export const SERVICES = [
    {
        key: "dent_repair",
        label: "Dent Repair",
        blurb: "Paintless and traditional dent removal with showroom finish.",
    },
    {
        key: "scratch_paintwork",
        label: "Scratch & Paintwork",
        blurb: "Color-matched touch-ups and full panel refinishing.",
    },
    {
        key: "bumper_repair",
        label: "Bumper Repair",
        blurb: "Crack, scuff, and structural repair for plastic bumpers.",
    },
    {
        key: "panel_replacement",
        label: "Panel Replacement",
        blurb: "OEM and aftermarket replacement panels, expertly fitted.",
    },
    {
        key: "full_respray",
        label: "Full Respray",
        blurb: "Complete repaints — concours-grade preparation and finish.",
    },
    {
        key: "alloy_wheels",
        label: "Alloy Wheel Repair",
        blurb: "Kerb scuff repair and full wheel refurbishment & repaint.",
    },
    {
        key: "rust_repair",
        label: "Rust Repair",
        blurb: "Cut-out, treat and refinish rust from minor spots to larger areas.",
    },
];

export const LEAD_STATUSES = [
    { key: "new", label: "New" },
    { key: "matched", label: "Matched" },
    { key: "completed", label: "Completed" },
];

export const SIZES = [
    { key: "small", label: "Small", note: "Smaller than a coin" },
    { key: "medium", label: "Medium", note: "Up to a hand" },
    { key: "large", label: "Large", note: "Across a panel" },
    { key: "severe", label: "Severe", note: "Multiple panels / structural" },
];

export const VEHICLES = [
    { key: "hatchback", label: "Hatchback" },
    { key: "sedan", label: "Sedan" },
    { key: "suv", label: "SUV" },
    { key: "truck", label: "Truck" },
    { key: "luxury", label: "Luxury" },
    { key: "sports", label: "Sports / Performance" },
];

export const formatPrice = (n) =>
    `NZ$${Math.round(n).toLocaleString("en-NZ")}`;
